import { useEffect, useRef, useState } from "react";
// import { useAuth } from "../context/Context";
// import { useDispatch, useSelector } from "react-redux";
// import * as action from '../Store/Action/Profile/Profile_Action';
import { toast } from "react-toastify";

const Profile = () => {
    // const { user } = useAuth();
    // const dispatch = useDispatch();
    // const { loading:updateProfileLoading } = useSelector(state => state.UpdateProfileReducer);
    // const { loading:updatePasswordLoading } = useSelector(state => state.UpdatePasswordReducer);
    const user = {}
    const [data, setData] = useState({
        first_name: user?.first_name || '',
        last_name: user?.last_name || '',
        phone: user?.phone || '',
        email: user?.email || '',
        address: user?.address || ''
    });
    const [passwordData, setPasswordData] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [errors, setErrors] = useState({});
    const firstNameRefFocus = useRef();
    const lastNameRefFocus = useRef();
    const phoneRefFocus = useRef();
    const addressRefFocus = useRef();
    const oldPasswordRefFocus = useRef();
    const newPasswordRefFocus = useRef();
    const confirmPasswordRefFocus = useRef();

    useEffect(() => {
        setData({
            first_name: user?.first_name || '',
            last_name: user?.last_name || '',
            phone: user?.phone || '',
            email: user?.email || '',
            address: user?.address || ''
        });
    }, [user]);

    const onChange = (e) => {
        setData({...data, [e.target.name] : e.target.value});
    }

    const onChangePassword = (e) => {
        setPasswordData({...passwordData, [e.target.name] : e.target.value});
    }

    const saveProfileData = (e) => {
        setErrors({});
        let customErrors = {};

        if(data.first_name === ''){
            customErrors.first_name = 'Please Enter First Name';
            firstNameRefFocus.current.focus();
        } else if(data.last_name === ''){
            customErrors.last_name = 'Please Enter Last Name';
            lastNameRefFocus.current.focus();
        } else if(data.phone === ''){
            customErrors.phone = 'Please Enter Phone';
            phoneRefFocus.current.focus();
        } else if(data.address === ''){
            customErrors.address = 'Please Enter Address';
            addressRefFocus.current.focus();
        }

        if (Object.keys(customErrors).length > 0) {
            setErrors(customErrors)
            return true
        }
        toast.error('update');
        // dispatch(action.updateProfile(data)).then((response) => {
        //     toast.success(response.responseMessage);
        //     let userData = response.responseDetails;
        //     setData({
        //         first_name: userData?.first_name || '',
        //         last_name: userData?.last_name || '',
        //         phone: userData?.phone || '',
        //         email: userData?.email || '',
        //         address: userData?.address || ''
        //     })
        // }).catch(error => {
        //     toast.error(error.responseMessage);
        // })
    }

    const savePasswordData = (e) => {
        setErrors({});
        let customErrors = {};
        let passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*_])[A-Za-z\d!@#$%^&*_]{8,}$/;

        if(passwordData.oldPassword === ''){
            customErrors.oldPassword = 'Please Enter Old Password';
            oldPasswordRefFocus.current.focus();
        } else if(passwordData.newPassword === ''){
            customErrors.newPassword = 'Please Enter New Password';
            newPasswordRefFocus.current.focus();
        } else if (!passwordRegex.test(passwordData?.newPassword)) {
            customErrors.newPassword = "The password must be at least 8 characters long and include one uppercase letter, one digit, and one special character." 
            newPasswordRefFocus.current.focus();
        } else if(passwordData.confirmPassword === ''){
            customErrors.confirmPassword = 'Please Enter Confirm Password';
            confirmPasswordRefFocus.current.focus();
        } else if(passwordData.newPassword !== passwordData.confirmPassword){
            customErrors.confirmPassword = 'New password and confirm password are not match';
            confirmPasswordRefFocus.current.focus();
        }

        if (Object.keys(customErrors).length > 0) {
            setErrors(customErrors)
            return true
        }
        toast.error('change Password');
        // dispatch(action.updatePassword(passwordData)).then((response) => {
        //     toast.success(response.responseMessage);
        //     setPasswordData({
        //         oldPassword: '',
        //         newPassword: '',
        //         confirmPassword: ''
        //     })
        // }).catch(error => {
        //     toast.error(error.responseMessage);
        // })
    }

    return (
        <section id="dashboard-section" className="dashboard-section section">
            <div className="row">
                {/* Update Profile */}
                <div className="col-xl-7 col-12">
                    <div className="industry-form-dtl">
                        <div className="form-content">
                            <h2>Profile</h2>
                            <form className="settings-form">
                                <div className="row"> 
                                    <div className="col-xxl-6 col-12">
                                        <div className="form-group">
                                            <label htmlFor="first_name">First Name</label>
                                            <div className="w-100">
                                                <input type="text" id="first_name" name="first_name" value={data.first_name} ref={firstNameRefFocus} placeholder="First Name" onChange={onChange} />
                                                <span className='small text-danger'>{errors?.first_name}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-6 col-12">
                                        <div className="form-group">
                                            <label htmlFor="last_name">Last Name</label>
                                            <div className="w-100">
                                                <input type="text" id="last_name" name="last_name" value={data.last_name} ref={lastNameRefFocus} placeholder="Last Name" onChange={onChange} />
                                                <span className='small text-danger'>{errors?.last_name}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-6 col-12">
                                        <div className="form-group">
                                            <label htmlFor="email">Email</label>
                                            <div className="w-100">
                                                <input type="email" id="email" name="email" value={data.email} placeholder="Email" readOnly />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-6 col-12">
                                        <div className="form-group">
                                            <label htmlFor="phone">Phone</label>
                                            <div className="w-100">
                                                <input type="text" id="phone" name="phone" value={data.phone} placeholder="Phone" onChange={onChange} ref={phoneRefFocus} />
                                                <span className='small text-danger'>{errors?.phone}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-6 col-12">
                                        <div className="form-group">
                                            <label htmlFor="address">Address</label>
                                            <div className="w-100">
                                                <input type="text" id="address" name="address" value={data.address} ref={addressRefFocus} placeholder="Address" onChange={onChange} />
                                                <span className='small text-danger'>{errors?.address}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-end">
                                        <button className="btn" type="button"onClick={(e) => saveProfileData(e)}>Save</button>
                                        {/* <button className="btn" type="button" disabled={updateProfileLoading} onClick={(e) => saveProfileData(e)}>
                                            {(updateProfileLoading) ? (
                                                <div className="spinner-border text-light" style={{width: '16px', height: '16px'}} role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : (
                                                "Save"
                                            )}
                                        </button> */}
                                    </div>
                                </div> 
                            </form>
                        </div> 
                    </div> 
                </div>

                {/* Change Password */}
                <div className="col-xl-5 col-12">
                    <div className="industry-form-dtl">
                        <div className="form-content">
                            <h2>Change Password</h2>
                            <form className="settings-form">
                                <div className="row"> 
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label htmlFor="oldPassword">Old Password</label>
                                            <div className="w-100">
                                                <input type="password" id="oldPassword" name="oldPassword" value={passwordData.oldPassword} ref={oldPasswordRefFocus} placeholder="Old Password" onChange={onChangePassword} />
                                                <span className='small text-danger'>{errors?.oldPassword}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label htmlFor="newPassword">New Password</label>
                                            <div className="w-100">
                                                <input type="password" id="newPassword" name="newPassword" value={passwordData.newPassword} ref={newPasswordRefFocus} placeholder="New Password" onChange={onChangePassword} />
                                                <span className='small text-danger'>{errors?.newPassword}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label htmlFor="confirmPassword">Confirm Password</label>
                                            <div className="w-100">
                                                <input type="text" id="confirmPassword" name="confirmPassword" value={passwordData.confirmPassword} placeholder="Confirm Password" onChange={onChangePassword} ref={confirmPasswordRefFocus} />
                                                <span className='small text-danger'>{errors?.confirmPassword}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-end">
                                        <button className="btn" type="button" onClick={(e) => savePasswordData(e)}>Update</button>
                                        {/* <button className="btn" type="button" disabled={updatePasswordLoading} onClick={(e) => savePasswordData(e)}>
                                            {(updatePasswordLoading) ? (
                                                <div className="spinner-border text-light" style={{width: '16px', height: '16px'}} role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : (
                                                "Update"
                                            )}
                                        </button> */}
                                    </div>
                                </div> 
                            </form>
                        </div> 
                    </div> 
                </div>
            </div>
        </section>
    );
};

export default Profile;